export default __webpack_public_path__ + "fonts/dcdb561fd1952a631a2750f351ad9259.svg";